<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { useEscapePriority } from 'dashboard/composables/useEscapePriority';

defineProps({
  url: {
    type: String,
    required: true,
  },
  fileName: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const dialogRef = ref(null);

// Sem isso, Escape fechava o preview E o ticket por baixo dele juntos — ver
// `useEscapePriority.js`: registra que este overlay está aberto, pra
// ConversationHeader's handler global de Escape (que fecha o ticket) ficar
// de fora enquanto o preview estiver na tela.
const isDialogOpen = ref(false);
useEscapePriority(isDialogOpen);

const open = () => {
  dialogRef.value?.open();
  isDialogOpen.value = true;
};

const handleDialogClose = () => {
  isDialogOpen.value = false;
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="fileName"
    width="3xl"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleDialogClose"
  >
    <iframe
      :src="url"
      :title="fileName"
      class="w-full h-[75vh] rounded-lg border border-n-container bg-white"
    />
    <template #footer>
      <a
        :href="url"
        rel="noreferrer noopener nofollow"
        target="_blank"
        class="w-full block bg-n-solid-3 px-4 py-2 rounded-lg text-sm text-center border border-n-container"
      >
        {{ t('CONVERSATION.DOWNLOAD') }}
      </a>
    </template>
  </Dialog>
</template>
